module.exports = __webpack_public_path__ + "static/media/remote_adventures_banner.8b3bcd60.png";